import { AppRoutes } from "./router";
import { BrowserRouter } from "react-router-dom";
import { useAuth } from "./hooks/useAuth";
import { useEffect } from "react";

function App() {
  const { user, loading } = useAuth();

  useEffect(() => {
    if (loading) return;

    const isOnLogin = window.location.pathname === '/login' || window.location.pathname.endsWith('/login');

    // Se está autenticado e na tela de login → vai para home
    if (user && isOnLogin) {
      window.REACT_APP_NAVIGATE('/');
      return;
    }

    // Se não está autenticado e não está no login → vai para login
    if (!user && !isOnLogin) {
      window.REACT_APP_NAVIGATE('/login');
    }
  }, [user, loading]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#0A0E13] via-[#0F1419] to-[#12161B]">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-[#39FF14] border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-[#A8B0BC]">Carregando...</p>
        </div>
      </div>
    );
  }

  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AppRoutes />
    </BrowserRouter>
  );
}

export default App;
